<template>
    <div class="DragonTreasure">
        <headerWX class="headerWX"></headerWX>
        <img class="bg" src="@/assets/imgs/DragonTreasure/bg.png" alt="">
        <div class="DragonTreasure_Content">
            <div class="tit">
                <img src="@/assets/imgs/DragonTreasure/tit.png" alt="">
            </div>
            <!-- 龙族宝库 -->
            <div class="Exchange public_btn">
                <img style="cursor: pointer;" @click="openWindow('Exchange')"
                    src="@/assets/imgs/DragonTreasure/Exchange_btn.png" alt="">
            </div>
            <!-- 进阶奖励-->
            <div class="Advanced public_btn">
                <img style="cursor: pointer;" @click="openWindow('Advanced')"
                    src="@/assets/imgs/DragonTreasure/Advanced_btn.png" alt="">
            </div>
            <!-- 规则 -->
            <div class="Rules public_btn">
                <img style="cursor: pointer;" @click="openWindow('Rules')"
                    src="@/assets/imgs/DragonTreasure/Rules_btn.png" alt="">
            </div>
            <!-- 奖池 -->
            <div class="PrizePool public_btn">
                <img style="cursor: pointer;" @click="openWindow('PrizePool')"
                    src="@/assets/imgs/DragonTreasure/PrizePool_btn.png" alt="">
            </div>
            <!-- 规则 -->
            <div class="Record public_btn">
                <img style="cursor: pointer;" @click="openWindow('Record')"
                    src="@/assets/imgs/DragonTreasure/Record_btn.png" alt="">
            </div>
            <!-- 抽取一次 -->
            <div class="ExtractOne public_btn">
                <img style="cursor: pointer;" @click="openHint(1)" src="@/assets/imgs/DragonTreasure/ExtractOne_btn.png"
                    alt="">
                <p>本次消费：5
                    <el-tooltip class="item" effect="dark" content="双旦好运币" placement="top">
                        <img src="@/assets/imgs/DragonTreasure/Currency1.png" alt="">
                    </el-tooltip>
                </p>
            </div>
            <!-- 抽取十次 -->
            <div class="ExtractTen public_btn">
                <img style="cursor: pointer;" @click="openHint(10)"
                    src="@/assets/imgs/DragonTreasure/ExtractTen_btn.png" alt="">
                <p>本次消费：50
                    <el-tooltip class="item" effect="dark" content="双旦好运币" placement="top">
                        <img src="@/assets/imgs/DragonTreasure/Currency1.png" alt="">
                    </el-tooltip>
                </p>
            </div>
            <!-- 剩余货币 -->
            <div class="CurrencySurplus public_btn">
                <img src="@/assets/imgs/DragonTreasure/CurrencySurplus.png" alt="">
                <p class="Surplus_num">双旦好运币：{{ DragonData.loveKeys }}</p>
            </div>
        </div>

        <div class="show_Window" v-if="show_Window" @click="() => {
            openPageScroll()
            show_Window = false
        }">
            <div class="Content" @click.stop>
                <img v-if="show_Window_type == 'PrizePool'" class="Content_bg"
                    src="@/assets/imgs/DragonTreasure/cmponent/bg1.png" alt="">
                <img v-else class="Content_bg" src="@/assets/imgs/DragonTreasure/cmponent/bg.png" alt="">
                <!-- 规则 -->
                <div class="Content_body" v-if="show_Window_type == 'Rules'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/DragonTreasure/cmponent/Rules_tit.png" alt="规则说明tit">
                    </div>
                    <div class="Rules_body Content_body_public">
                        <div class="tit">活动时间：<span> 2025年12月26日—2026年1月11日24点</span></div>
                        <p>1.一个金龙元宝可以兑换一个双旦好运币。</p>
                        <p>2.活动结束后，未曾使用的双旦好运币、龙族秘宝碎片将失效将失效，请于活动截止前及时使用。</p>
                        <p>3.消耗双旦好运币可抽取秘宝并获得对应奖励，活动奖励请于网站商城—个人仓库查收。</p>
                        <p>4.抽取秘宝有概率获得龙族秘宝碎片，可用于在龙族宝库中兑换珍稀道具。</p>
                        <p>5.累计抽取一定次数可在进阶奖励中领取相应的宝箱。</p>
                        <p>6.除可重复获得奖励外，其余奖励仅会被抽取1次。</p>
                        <p>7.初始概率公式：</p>
                        <div class="itm tindent">
                            <table>
                                <thead>
                                    <tr>
                                        <th>道具</th>
                                        <th>初始概率</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>超导破坏炮MKX-终(36星)（绑定）</td>
                                        <td>0.05%</td>
                                    </tr>
                                    <tr>
                                        <td>超导破坏炮MKII-终(36星)（绑定）</td>
                                        <td>0.1%</td>
                                    </tr>
                                    <tr>
                                        <td>双十二36星精品福袋</td>
                                        <td>0.35%</td>
                                    </tr>
                                    <tr>
                                        <td>双十二33星精品福袋</td>
                                        <td>1%</td>
                                    </tr>
                                    <tr>
                                        <td>一大袋源土（绑定）</td>
                                        <td>1.5%</td>
                                    </tr>
                                    <tr>
                                        <td>赤铜龙魂箱（绑定）</td>
                                        <td>3%</td>
                                    </tr>
                                    <tr>
                                        <td>龙族秘宝碎片X3</td>
                                        <td>5%</td>
                                    </tr>
                                    <tr>
                                        <td>龙族秘宝碎片X2</td>
                                        <td>15%</td>
                                    </tr>
                                    <tr>
                                        <td>龙族秘宝碎片X1</td>
                                        <td>30%</td>
                                    </tr>
                                    <tr>
                                        <td>双旦小福袋X1（绑定）</td>
                                        <td>44%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p>8.道具-双旦小福袋获取概率：</p>
                        <div class="itm tindent">
                            <table>
                                <thead>
                                    <tr>
                                        <th>道具</th>
                                        <th>初始概率</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>赤铜龙魂箱X1</td>
                                        <td>0.5%</td>
                                    </tr>
                                    <tr>
                                        <td>五阶天性强化果x1</td>
                                        <td>14.5%</td>
                                    </tr>
                                    <tr>
                                        <td>外表重修果x1</td>
                                        <td>15.0%</td>
                                    </tr>
                                    <tr>
                                        <td>完美卡片升级钻石x30</td>
                                        <td>20.0%</td>
                                    </tr>
                                    <tr>
                                        <td>完美卡片升级宝石x30</td>
                                        <td>20.0%</td>
                                    </tr>
                                    <tr>
                                        <td>六倍经验果x5</td>
                                        <td>30.0%</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="Rules_btn Content_btn_public"></div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 奖池 -->
                <div class="Content_body" v-if="show_Window_type == 'PrizePool'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/DragonTreasure/cmponent/Preview_tit.png" alt="奖池预览">
                    </div>
                    <div class="PrizePool_body Content_body_public">
                        <!-- 特殊奖励 -->
                        <div class="Special">
                            <div class="tit">特殊奖励</div>
                            <div class="items">
                                <div class="it" v-for="value in PrizePoolList(1)" :key="value.itemId">
                                    <el-tooltip class="item" effect="dark" :content="value.itemDesc" placement="top">
                                        <img :src="value.itemImg" alt="">
                                    </el-tooltip>

                                    <p>{{ value.itemName }}</p>
                                    <div v-if="value.status == 1" class="Obtained">已获取</div>
                                </div>
                            </div>

                        </div>
                        <!-- 普通奖励 -->
                        <div class="Ordinary">
                            <div class="tit">可重复获得奖励</div>
                            <div class="items">
                                <div class="item" v-for="value in PrizePoolList(0)">
                                    <img :src="value.itemImg" alt="">
                                    <p>{{ value.itemName }}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="PrizePool_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/DragonTreasure/cmponent/Sure_btn.png" alt="">
                    </div>

                </div>
                <!-- 记录 -->
                <div class="Content_body" v-if="show_Window_type == 'Record'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/DragonTreasure/cmponent/Record_tit.png" alt="获取记录">
                    </div>
                    <div class="Record_body Content_body_public">
                        <div class="Record_body_tit items">
                            <div>获取时间</div>
                            <div>奖励名称</div>
                        </div>
                        <div class="items" v-for="(value, index) in RecordList" :key="index">
                            <div>{{ value.drawTime }}</div>
                            <div>{{ value.prizeName }}</div>
                        </div>
                    </div>
                    <div class="Record_btn Content_btn_public">
                        <el-pagination background :hide-on-single-page="true" :page-size='10' :total="RecordTotal"
                            layout="prev, pager, next" @current-change="pagination_change">
                        </el-pagination>
                    </div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 兑换 -->
                <div class="Content_body" v-if="show_Window_type == 'Exchange'">
                    <div class="Content_body_Tit Exchange_tit">
                        <img src="@/assets/imgs/DragonTreasure/cmponent/Exchange_tit.png" alt="获取记录">
                        <div class="Currency">
                            <img src="@/assets/imgs/DragonTreasure/CurrencySurplus.png" alt="">
                            <p class="Surplus_num">龙族秘宝碎片：{{ DragonData.loveKeys2 }}</p>
                        </div>
                    </div>
                    <div class="Exchange_body Content_body_public">
                        <div class="items">

                            <div :class="['it', ExchangeIndex == index ? 'Choose' : '']"
                                v-for="(value, index) in DragonData.hiddenShopItems" :key="value.itemId" @click="() => {
                                    ExchangeIndex = index
                                }">
                                <el-tooltip class="item" effect="dark" :content="value.itemDesc" placement="top">
                                    <img :src="value.itemImg" alt="">
                                </el-tooltip>
                                <p style="">{{ value.itemName }}</p>
                                <p class="price"><img src="@/assets/imgs/DragonTreasure/Currency2.png" alt=""> &nbsp; X
                                    {{
                                        value.price }}</p>
                                <p v-if="value.limitCount != 0">({{ value.buyCount }}/{{ value.limitCount }})</p>
                            </div>
                        </div>
                    </div>
                    <div class="Exchange_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/DragonTreasure/cmponent/Cancel_btn.png" alt="">
                        <img @click="Exchange_Sure" src="@/assets/imgs/DragonTreasure/cmponent/Exchange_btn.png" alt="">
                    </div>
                </div>
                <!-- 进阶奖励 -->
                <div class="Content_body" v-if="show_Window_type == 'Advanced'">
                    <div class="Content_body_Tit">
                        <img src="@/assets/imgs/DragonTreasure/cmponent/Advanced.tit.png" alt="进阶奖励">
                    </div>
                    <div class="Advanced_body Content_body_public">
                        <div class="tit">
                            当前抽取次数：{{ DragonData.totalDrawCount }}
                        </div>
                        <div class="items">
                            <div class="it" v-for="value in DragonData.milestoneList" :key="value.itemId">
                                <div class="milestoneCount">累计抽取{{ value.milestoneCount }}次领取</div>
                                <div class="itemDesc">{{ value.itemName }}</div>
                                <el-tooltip class="item" effect="dark" :content="value.itemDesc" placement="top">
                                    <img :src="value.itemImg" alt="">
                                </el-tooltip>

                                <!-- <img src="@/assets/imgs/DragonTreasure/coin.png" alt=""> -->
                                <img v-if="value.status == 0" style="filter: grayscale(100%);" @click="() => {
                                    $message.info('抽取次数不足')
                                }" src="@/assets/imgs/DragonTreasure/cmponent/Claim_btn.png" alt="">
                                <img v-else-if="value.status == 1" @click="AdvancedFun(value.milestoneCount)"
                                    src="@/assets/imgs/DragonTreasure/cmponent/Claim_btn.png" alt="">
                                <img v-else-if="value.status == 2"
                                    src="@/assets/imgs/DragonTreasure/cmponent/Collected.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="Close" @click="() => {
                        openPageScroll()
                        show_Window = false
                    }">X</div>
                </div>
                <!-- 抽取奖励 -->
                <div class="Content_body" v-if="show_Window_type == 'LotteryDraw'">
                    <div class="LotteryDraw_body Content_body_public">
                        <div class="item" v-for="(value, index) in LotteryDrawList" :key="index">
                            <img :src="value.itemImg" alt="">
                            <p>{{ value.itemName }}</p>
                        </div>

                    </div>
                    <div class="LotteryDraw_btn Content_btn_public" style="flex-wrap: wrap;">
                        <img style="cursor: pointer; width: 150px;margin-right: 30px;" @click="DirectLotteryDrawFun(1)"
                            src="@/assets/imgs/DragonTreasure/ExtractOne_btn.png" alt="">
                        <img style="cursor: pointer; width: 150px;margin-left: 30px;" @click="DirectLotteryDrawFun(10)"
                            src="@/assets/imgs/DragonTreasure/ExtractTen_btn.png" alt="">
                        <div style="width: 100%;text-align: center;">
                            <img @click="() => {
                                openPageScroll()
                                show_Window = false
                                init()
                            }" src="@/assets/imgs/DragonTreasure/cmponent/Sure_btn.png" alt="">
                        </div>
                    </div>
                </div>

                <!-- 兑换双旦好运币 -->
                <div class="Content_body" v-if="show_Window_type == 'ExchangeLotteryCurrency'">

                    <div class="ExchangeLotteryCurrency_body Content_body_public">
                        <!-- 兑换提示 -->
                        <p class="hint">双旦好运币不足，需要使用1个金龙元宝兑换1个双旦好运币？</p>
                        <!-- <p class="hint" v-if="nextDrawCost">本次抽奖需<span>{{ nextDrawCost }}</span>个壮行酒</p> -->
                        <!-- 兑换图展示 -->
                        <div class="conversion_img">
                            <img src="@/assets/imgs/DragonTreasure/coin.png" alt="">
                            <p>1:1</p>
                            <img src="@/assets/imgs/DragonTreasure/Currency1.png" alt="">
                        </div>
                        <!-- 兑换 -->
                        <div class="conversion_input">
                            <span>兑换 :</span>
                            <input type="text" v-model="conversion_number">
                        </div>
                        <div class="ConfirmExchange">
                            <img @click="() => {
                                openPageScroll()
                                show_Window = false
                            }" src="@/assets/imgs/Kingdoms/component/cancel.png" alt="">
                            <img @click="ExchangeLotteryCurrencyConfirmFun"
                                src="@/assets/imgs/Kingdoms/component/conversion.png" alt="">
                        </div>

                        <div class="CurrencySurplus">
                            金龙元宝剩余：{{ userInfo?.wallteInfos?.[0]?.balance }}
                        </div>
                    </div>
                </div>
                <!-- 抽奖确认提示 -->
                <div class="Content_body" v-if="show_Window_type == 'LotteryDrawHint'">
                    <div class="LotteryDrawHint_body Content_body_public">
                        <p>确定抽奖吗</p>
                        <p>本次消耗：{{ drawType * 5 }}双旦好运币</p>
                    </div>
                    <div class="Exchange_btn Content_btn_public">
                        <img @click="() => {
                            openPageScroll()
                            show_Window = false
                        }" src="@/assets/imgs/DragonTreasure/cmponent/Cancel_btn.png" alt="">
                        <img @click="LotteryDrawFun" src="@/assets/imgs/DragonTreasure/cmponent/Sure_btn.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headerWX from "@/components/Header";
import Cookies from 'js-cookie'
import { getMemberInfoApi } from '@/api/public.js'
import { getActivityInfoApi, buyHiddenShopItemApi, lotteryApi, exchangeApi, getActivityLogApi, claimMilestoneRewardApi } from '@/api/DragonTreasure'
export default {
    components: {
        headerWX
    },
    data() {
        return {
            //弹窗控制
            show_Window: false,
            //弹窗类型
            show_Window_type: '',
            //兑换 index
            ExchangeIndex: null,
            // 兑换的数量
            conversion_number: 1,

            //抽奖获取的List
            LotteryDrawList: [],

            //  获取记录total
            RecordTotal: 0,
            //  获取记录List
            RecordList: [],

            //用户信息
            userInfo: [],
            //数据
            DragonData: [],
            // 是否可以抽奖
            isExtract: true,
            // 抽奖类型
            drawType: null
        }
    },

    created() {
        this.init()
        this.getMemberInfo()
        this.openPageScroll()
    },
    mounted() {

    },
    computed: {
        PrizePoolList() {
            return (targetLimit) => {
                // 过滤出 limitCount 等于目标值的奖品
                return this.DragonData.allPrizes.filter(prize => prize.limitCount === targetLimit);
            };
        }
    },
    methods: {


        //开启弹窗
        openWindow(type) {
            console.log(type);
            this.closePageScroll()//关闭滚动条
            this.show_Window_type = type
            this.show_Window = true
            if (type == 'Record') {
                this.RecordFun(1)
            }
        },
        // 切换产看记录
        pagination_change(e) {
            this.RecordFun(e)
        },
        //获取抽奖记录
        async RecordFun(Page) {
            await getActivityLogApi({
                activityName: '2025christmas_activity',
                currentPage: Page,
                pageSize: 10,
                userId: Cookies.get("cwsl_userId"),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.RecordTotal = data.data.total
                    this.RecordList = data.data.list
                } else {
                    this.$message.info(data.message)
                }
            })
        },

        //领取进阶奖励
        async AdvancedFun(milestoneCount) {

            await claimMilestoneRewardApi({
                activityName: '2025christmas_activity',
                milestoneId: milestoneCount,
                userId: Cookies.get("cwsl_userId"),
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.$message.success(data.message)
                    this.init()
                } else {
                    this.$message.info(data.message)
                }
            })
        },


        //兑换 龙族秘宝
        async Exchange_Sure() {

            if (this.ExchangeIndex == null) {
                this.$message.info('请选择所兑换的宝物！')
                return
            }
            const loveKeys2 = this.DragonData.loveKeys2;
            const Item = this.DragonData.hiddenShopItems[this.ExchangeIndex];
            // console.log(loveKeys2,Item.price,this.DragonData);
            
            if (loveKeys2 < Item.price) {
                this.$message.info('龙族秘宝碎片不足！！！')
            } else {
                await buyHiddenShopItemApi({
                    activityName: '2025christmas_activity',
                    buyNum: 1,
                    itemId: Item.itemId,
                    userId: Cookies.get("cwsl_userId"), // userId
                }).then(({ data }) => {
                    if (data.state == 200) {
                        this.$message.success(data.data.message)
                        this.ExchangeIndex = null
                        this.init()
                    } else {
                        this.$message.info(data.message)
                    }
                })
            }
        },

        // 兑换 双旦好运币
        async ExchangeLotteryCurrencyConfirmFun() {
            const userBalance = this.userInfo?.wallteInfos?.[0]?.balance;
            if (this.conversion_number > userBalance) {
                this.$message.info('金龙元宝不足！！！')
            } else {
                await exchangeApi({
                    exchangeAmount: this.conversion_number,
                    userId: Cookies.get("cwsl_userId")
                }).then(({ data }) => {
                    if (data.state == 200) {
                        this.$message.success(data.data.message)
                        this.openPageScroll()
                        this.show_Window = false
                        this.init()
                        this.getMemberInfo()
                    } else {
                        this.$message.info(data.message)
                    }
                })
            }

        },

        openHint(type) {
            const loveKeys = this.DragonData.loveKeys;
            this.drawType = type
            switch (type) {
                case 1:
                    if (loveKeys < 5) {
                        this.openWindow('ExchangeLotteryCurrency')
                        return
                    }
                    this.openWindow('LotteryDrawHint')
                    break;
                case 10:
                    if (loveKeys < 50) {
                        this.openWindow('ExchangeLotteryCurrency')
                        return
                    }
                    this.openWindow('LotteryDrawHint')
                    break;
                default:
                    break;
            }
        },

        //抽奖 1次 10次
        async LotteryDrawFun() {
            await lotteryApi({
                activityName: '2025christmas_activity',
                drawType: this.drawType,
                userId: Cookies.get("cwsl_userId"), // userId
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.LotteryDrawList = data.data.prizes
                    this.drawType = null
                    this.openWindow('LotteryDraw')
                    this.getMemberInfo()
                    this.init()
                } else {
                    this.$message.info(data.message)
                }
            })

        },
        // 直接抽奖 
        DirectLotteryDrawFun(type) {
            const loveKeys = this.DragonData.loveKeys;

            const fu = async (type) => {
                await lotteryApi({
                    activityName: '2025christmas_activity',
                    drawType: type,
                    userId: Cookies.get("cwsl_userId"), // userId
                }).then(({ data }) => {
                    if (data.state == 200) {
                        this.LotteryDrawList = data.data.prizes
                        this.drawType = null
                        this.getMemberInfo()
                        this.init()
                    } else {
                        this.$message.info(data.message)
                    }
                })
            }
            switch (type) {
                case 1:
                    if (loveKeys < 5) {
                        this.openWindow('ExchangeLotteryCurrency')
                        return
                    }
                    fu(type)
                    break;
                case 10:
                    if (loveKeys < 50) {
                        this.openWindow('ExchangeLotteryCurrency')
                        return
                    }
                    fu(type)
                    break;
                default:
                    break;
            }

        },

        //获取 user信息
        async getMemberInfo() {
            await getMemberInfoApi({
                userId: Cookies.get('cwsl_userId'),      // userId
                platForm: 'web',
            }).then((res) => {
                if (res.data.state == 200) {
                    this.userInfo = res.data.data
                    this.resetSetItem('userInfo', JSON.stringify(res.data.data))
                } else {
                    this.$message.error(res.data.message)
                }
            }).catch(err => {
                this.$message.error(err.message)
            })
        },

        // 初始化
        async init() {
            await getActivityInfoApi({
                activityName: "2025christmas_activity",
                userId: Cookies.get("cwsl_userId"), // userId
                platForm: "web",
            }).then(({ data }) => {
                if (data.state == 200) {
                    this.DragonData = data.data
                } else {
                    this.$message.info(data.message)
                }
            })
        },

        // 关闭页面滚动条
        closePageScroll() {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        },

        // 开启页面滚动条
        openPageScroll() {
            document.body.style.overflow = 'auto';
            document.documentElement.style.overflow = 'auto';
        },
    },

}
</script>

<style>
body {
    background-image: linear-gradient(to bottom, #343e44 0%, #5d666f 50%, #4e4541 100%) !important;
}
</style>

<style lang="less" scoped>
.DragonTreasure {
    position: relative;
    min-width: 1200px;
    max-width: 2000px;
    margin: auto;

    .bg {
        width: 100%;
    }

    .headerWX {
        width: 100%;
        transform: scale(0.8);
        position: absolute;
        top: 3%;
    }

    .DragonTreasure_Content {
        position: absolute;
        top: 14%;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 85%;

        .tit {
            text-align: center;

            >img {
                max-width: 20%;
            }
        }

        .public_btn {
            position: absolute;

            >img {
                max-width: 100%;
            }
        }

        .Exchange {
            left: 10%;
            width: 10%;
        }

        .Advanced {
            top: 25%;
            left: 10%;
            width: 10%;
        }

        .Rules {
            right: 10%;
            width: 10%;
        }

        .PrizePool {
            right: 10%;
            top: 25%;
            width: 10%;
        }

        .Record {
            right: 10%;
            top: 39%;
            width: 10%;
        }

        .ExtractOne {
            bottom: 15%;
            left: 34%;
            width: 15%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                color: #fff;
                font-weight: 700;
                text-shadow:
                    -1px -1px 0 #000,
                    1px -1px 0 #000,
                    -1px 1px 0 #000,
                    1px 1px 0 #000;

                >img {
                    width: 20%;
                }
            }
        }

        .ExtractTen {
            bottom: 15%;
            right: 29%;
            width: 15%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                color: #fff;
                font-weight: 700;
                text-shadow:
                    -1px -1px 0 #000,
                    1px -1px 0 #000,
                    -1px 1px 0 #000,
                    1px 1px 0 #000;

                >img {
                    width: 20%;
                }
            }
        }

        .CurrencySurplus {
            bottom: 5%;
            right: 40%;
            width: 15%;

            >img {
                width: 100%;
            }

            .Surplus_num {
                width: 85%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                text-align: center;
                color: #fff;
                font-weight: 600;
            }
        }
    }

    .show_Window {
        position: fixed;
        top: 0%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(95, 94, 92, 0.527);
        z-index: 1000;
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(12px);

        .Content {
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 800px;
            height: fit-content;

            .Content_bg {
                width: 100%;
            }

            .Content_body {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 95%;
                height: 90%;

                .Close {
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    width: 30px;
                    height: 30px;
                    border: 2px solid #fff;
                    border-radius: 50%;
                    line-height: 30px;
                    text-align: center;
                    font-size: 20px;
                    color: #fff;
                    cursor: pointer;
                }

                .Content_body_Tit {
                    width: 100%;
                    margin-top: 2%;
                    text-align: center;

                    >img {
                        width: 15%;
                    }
                }

                //兑换
                .Exchange_tit {
                    text-align: center;
                    position: relative;

                    .Currency {
                        position: absolute;
                        top: 0;
                        right: 5%;
                        width: 18%;

                        >img {
                            width: 100%;
                        }

                        p {
                            width: 95%;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            font-size: 12px;
                            color: #fff;
                            font-weight: 700;
                        }
                    }
                }

                // 公用
                .Content_body_public {
                    width: 100%;
                    height: 75%;
                    // background-color: #00ff5586;
                }

                .Content_btn_public {
                    height: 10%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                //规则
                .Rules_body {
                    height: 78%;
                    overflow: auto;
                    padding-top: 10px;

                    .tit {
                        font-size: 24px;
                        text-align: center;
                        color: #fff;

                        >span {
                            color: red;
                            font-size: 24px;
                            font-weight: 600;
                        }
                    }

                    >p {
                        text-indent: 2em;
                        font-size: 18px;
                        line-height: 32px;
                        width: 80%;
                        margin: auto;
                        color: #fff;
                    }

                    .itm {
                        line-height: 30px;
                        color: #ffffff;
                        font-size: 18px;

                        span {
                            font-size: 20px;
                        }

                        table {
                            width: 500px;
                            border-collapse: collapse;
                            margin: 20px auto;
                        }

                        table,
                        th,
                        td {
                            border: 1px solid #82673e;
                        }

                        th,
                        td {
                            text-align: center;
                            padding: 8px;
                        }
                    }
                }

                // 奖池
                .PrizePool_body {
                    height: 82%;

                    .tit {
                        width: 99%;
                        text-align: center;
                        line-height: 30px;
                        background-color: #ffffff79;
                        color: #fff;
                        font-weight: 700;
                        font-size: 18px;
                        margin: auto;
                        border-radius: 10px;
                    }

                    .Special {
                        height: 60%;
                        display: flex;
                        flex-direction: column;

                        .items {
                            flex: 1;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 0 15%;
                            justify-content: center;
                            align-items: flex-end;

                            .it {
                                width: 130px;
                                height: 120px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                gap: 20px;
                                color: #fff;
                                background-color: #ffffff79;
                                border-radius: 10px;
                                margin-bottom: 10px;
                                position: relative;

                                >img {
                                    max-width: 50px;
                                }

                                >p {
                                    width: 100%;
                                    text-align: center;
                                    text-wrap: wrap;
                                }

                                .Obtained {
                                    position: absolute;
                                    top: 50%;
                                    width: 100%;
                                    background-color: #04030291;
                                    color: #dba16e;
                                    text-align: center;
                                    padding: 10px 0;
                                    transform: translateY(-50%);
                                    font-weight: 700;
                                }
                            }
                        }
                    }

                    .Ordinary {
                        height: 40%;

                        .items {
                            margin-top: 25px;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 0 6%;
                            justify-content: center;
                            align-items: flex-end;

                            .item {
                                width: 130px;
                                height: 120px;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                flex-direction: column;
                                gap: 20px;
                                color: #fff;
                                background-color: #ffffff79;
                                border-radius: 10px;

                                >p {
                                    width: 100%;
                                    text-align: center;
                                    text-wrap: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                            }
                        }
                    }
                }

                //记录
                .Record_body {
                    width: 100%;
                    margin: auto;
                    color: #fff;

                    .Record_body_tit {
                        >div {
                            font-size: 20px;
                            font-weight: 700;
                        }
                    }

                    .items {
                        width: 100%;
                        display: flex;

                        >div {
                            flex: 1;
                            text-align: center;
                            margin: 8px;
                        }
                    }
                }


                //兑换
                .Exchange_body {
                    height: 78%;

                    .items {
                        height: 100%;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 0 5%;
                        justify-content: center;
                        align-items: center;


                        .it {
                            padding: 5px 10px;
                            width: 150px;
                            height: 150px;
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            flex-direction: column;
                            gap: 8px;
                            color: #fff;
                            background-color: #ffffff79;
                            border-radius: 10px;
                            cursor: pointer;

                            >img {
                                width: 50px;
                                height: 50px;
                            }

                            >p {
                                width: 100%;
                                white-space: wrap;
                                text-align: center;
                                font-size: smaller;
                            }

                            .price {
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                >img {
                                    width: 30px;

                                }
                            }
                        }

                        .Choose {
                            border-color: #00f7ff;
                            box-shadow: 0 0 10px #00f7ff, 0 0 20px #00f7ff, 0 0 30px #00f7ff;
                            animation: pulse-border 0.6s ease-out;
                        }

                        @keyframes pulse-border {
                            0% {
                                box-shadow: 0 0 0 0 rgba(0, 247, 255, 0.7);
                            }

                            70% {
                                box-shadow: 0 0 0 12px rgba(5, 114, 117, 0.418);
                            }

                            100% {
                                box-shadow: 0 0 0 0 rgba(2, 233, 241, 0.979);
                            }
                        }
                    }
                }

                .Exchange_btn {

                    gap: 12%;

                    >img {
                        width: 10%;
                        cursor: pointer;
                    }
                }

                //进阶奖励
                .Advanced_body {
                    display: flex;
                    flex-direction: column;

                    .tit {
                        width: 100%;
                        line-height: 30px;
                        color: #fff;
                        text-align: center;
                    }

                    .items {
                        flex: 1;
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;

                        .it {
                            width: 180px;
                            height: 250px;
                            background-color: #ffffff77;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;
                            gap: 10px;
                            border-radius: 20px;

                            .milestoneCount {
                                color: #fff;
                                font-size: 14px;
                                font-weight: 700;
                            }

                            .itemDesc {
                                color: #fff;
                                font-size: 17px;
                                font-weight: 700;
                                text-align: center;
                            }

                        }
                    }
                }


                //抽取奖励
                .LotteryDraw_body {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 40px;
                    justify-content: center;
                    align-content: center;

                    .item {
                        width: 110px;
                        height: 120px;
                        background-color: #ffffff69;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        gap: 10px;
                        border-radius: 10px;

                        >img {
                            width: 60px;
                        }

                        >p {
                            width: 100%;
                            text-align: center;
                            color: #fff;
                        }
                    }
                }

                // 兑换双旦好运币
                .ExchangeLotteryCurrency_body {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;

                    .hint {
                        font-size: 20px;
                        color: #fff;
                        font-weight: 700;
                    }

                    .conversion_img {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 20px 0;

                        >img {
                            // width: 100px;
                            max-height: 80px;
                        }

                        >p {
                            font-size: 50px;
                            font-weight: 600;
                            margin: 0 50px;
                            color: #d2d07b;
                            font-family: Verdana, Geneva, Tahoma, sans-serif;
                        }
                    }

                    .conversion_input {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;
                        left: -5%;

                        span {
                            font-size: 24px;
                            margin-right: 30px;
                            color: #fff;
                            font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;

                        }

                        input {
                            line-height: 40px;
                            border-radius: 20px;
                            text-align: center;
                            font-size: 20px;
                            background-color: #c6492e;
                            color: #fff;
                            border: 1px solid #fff;
                        }

                        input:focus {
                            outline: 2px solid #fce18d;
                            border: 1px solid #fce18d;

                            /* 获得焦点时显示绿色轮廓 */
                        }

                    }

                    .ConfirmExchange {
                        margin: 30px 0;
                        text-align: center;

                        >img {
                            margin: 0 20px;
                        }
                    }

                    .CurrencySurplus {
                        padding: 20px;
                        background-color: #ffffff75;
                        border-radius: 20px;
                        font-size: 20px;
                        color: #fff;
                        font-weight: 700;
                    }
                }

                //抽奖确认提示
                .LotteryDrawHint_body {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;

                    >p {
                        text-align: center;
                        color: #fff;
                        font-size: 24px;
                        padding-bottom: 20px;
                    }
                }
            }
        }
    }
}
</style>